import { BadgeProps } from '@razorpay/blade/components';
import { FlexiClaimStatus } from './types';

export const formatPaginationRange = ({
  totalItems,
  currentPage,
  itemsPerPage,
}: {
  totalItems: number;
  currentPage: number;
  itemsPerPage: number;
}) => {
  if (totalItems === 0) {
    return null;
  }

  const startItem = currentPage * itemsPerPage + 1;
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalItems);

  return `${startItem}-${endItem} of ${totalItems}`;
};

export const getClaimStatusColor = (status: FlexiClaimStatus): BadgeProps['color'] => {
  switch (status) {
    case 'APPROVED':
      return 'positive';
    case 'REJECTED':
      return 'negative';
    case 'SUBMITTED':
      return 'information';
    case 'PARTIALLY_APPROVED':
      return 'positive';
    default:
      return 'notice';
  }
};

export const getClaimStatusTitle = (status: FlexiClaimStatus): string => {
  switch (status) {
    case 'APPROVED':
      return 'Approved';
    case 'REJECTED':
      return 'Rejected';
    case 'PARTIALLY_APPROVED':
      return 'Approved';
    case 'SUBMITTED':
    default:
      return 'Pending';
  }
};
